import { render } from "./StatsPad.vue?vue&type=template&id=9f44fcb8&scoped=true"
import script from "./StatsPad.vue?vue&type=script&lang=js"
export * from "./StatsPad.vue?vue&type=script&lang=js"

import "./StatsPad.vue?vue&type=style&index=0&id=9f44fcb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f44fcb8"],['__file',"src/components/StatsPad.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9f44fcb8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9f44fcb8', __exports__)) {
    api.reload('9f44fcb8', __exports__)
  }
  
  module.hot.accept("./StatsPad.vue?vue&type=template&id=9f44fcb8&scoped=true", () => {
    api.rerender('9f44fcb8', render)
  })

}


export default __exports__